<template>
    <div class="create-documents">
        <div class="header">
            <div class="title">
                <span class="main">Добавление продукта. </span>
                <span class="sub">Загрузка документов</span>
            </div>
        </div>

        <div class="middle">
            <InformNotice v-if="showInform" class="inform">
                <template #text>
                    По возможности добавьте презентационные материалы или другие документы по продукту
                </template>
            </InformNotice>

            <Documents :can-add-group="true"
                       :can-edit="true"
                       :max-file-size="0"
                       :documents.sync="documents"
                       :groups.sync="documentGroups"
                       calc-size-only-uploaded
                       class="documents"
                       @editGroup="onEditGroup"
            />
        </div>

        <div class="footer two-sided">
            <div class="left">
                <button class="only-icon back" @click="$emit('back')">
                    <IconArrowLeft class="icon" />
                </button>
            </div>
            <div class="right">
                <input class="ghost"
                       type="button"
                       value="Отмена"
                       @click="$emit('close')"
                />
                <Tooltip :opened="v.$invalid" by-hover center class="tooltip" sideways trigger-on="hover">
                    <template #target="{ on }">
                        <input :disabled="v.$invalid"
                               class="primary"
                               type="button"
                               value="Далее"
                               @click="onNext"
                               v-on="on"
                        />
                    </template>
                    <template #default>
                        <span>Необходимо подтвердить добавление документа</span>
                    </template>
                </Tooltip>
            </div>
        </div>

        <EditDocumentGroup ref="editDocumentGroup" :can-edit-attachment="true" class="edit-document-group" />
    </div>
</template>

<script>
import DocumentGroup from '@/common/page_comp/Documents/documentGroup.js';
import EditDocumentGroup from '@/common/page_comp/Documents/EditDocumentGroup.vue';
import InformNotice from '@/common/page_comp/InformNotice/InformNotice.vue';
import { useVuelidate } from '@vuelidate/core';
import Documents from '../../Documents/DocumentsAdd.vue';


export default {
    name: 'CreateDocuments',
    setup() {
        return {
            v: useVuelidate(),
        };
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        showInform: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        InformNotice,
        Documents,
        EditDocumentGroup,
    },
    data() {
        return {
            documents: [],
            documentGroups: [],
        };
    },
    methods: {
        onNext() {
            this.$emit('next', {
                documents: this.documents,
                documentGroups: this.documentGroups,
            });
        },
        async onEditGroup(group) {
            if (!group) {
                group = new DocumentGroup({
                    accessType: 'PUBLIC',
                });
            }

            const resp = await this.$refs.editDocumentGroup.open(group);
            if (!resp || resp.id)
                return;

            const groupIndex = this.documentGroups.findIndex((it) => it === group);
            if (groupIndex < 0)
                this.documentGroups.push(resp);
        },
    },
    created() {
        this.documents = [].concat(this.value.documents ?? []);
        this.documentGroups = [].concat(this.value.documentGroups ?? []);
    },
};
</script>

<style lang="scss" scoped>
.create-documents {
    .inform {
        margin-bottom: 20px;
    }

    .documents {
        margin-bottom: 20px;
    }

    .tooltip {
        display: inline-flex;
    }

}

.edit-document-group {
    width: 962px;
}
</style>
